"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBar = void 0;
const react_1 = __importStar(require("react"));
//@ts-ignore
const lodash_1 = __importDefault(require("lodash"));
const react_i18next_1 = require("react-i18next");
const option_1 = require("../option");
const Icon_1 = __importDefault(require("./Icon"));
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const MenuBar = react_1.default.memo(({ isRow, isClickDisabled = false, className, option, value, list, styles, onItemClick, setIsHovered, isHovered, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [menu, setMenu] = (0, react_1.useState)(value);
    const menubarOption = (0, react_1.useMemo)(() => lodash_1.default.merge({}, option_1.MenuBarOption, option), [option]);
    (0, react_1.useEffect)(() => {
        if (!value)
            return;
        if (value !== menu)
            setMenu(value);
    }, [value]);
    // 메뉴 변경 함수
    const changeMenu = (changeMenu) => {
        if (!isClickDisabled) {
            onItemClick(changeMenu);
        }
    };
    // render Items
    const renderItems = (data) => {
        const { item, isFocus, className, changeMenu } = data;
        return (react_1.default.createElement("div", { key: item, className: `menubar-item ${className} ${menu === 'home' && isHovered ? 'hovered' : ''}`, onMouseEnter: setIsHovered ? () => isDesktop && setIsHovered(true) : undefined, style: styles?.menuItem, onClick: e => changeMenu(item) },
            menubarOption.titleIcon.show && (react_1.default.createElement(Icon_1.default, { icon: `${item}_${isFocus ? 'on' : 'off'}`, size: menubarOption.titleIcon.size })),
            react_1.default.createElement("p", null, t(`menu.${item}`))));
    };
    return (react_1.default.createElement("div", { className: `menubar-wrap flex ${isRow ? 'row' : 'column'} ${className}`, style: styles?.menuWrap }, list.map(item => renderItems({
        item,
        isFocus: menu === item,
        className: menu === item ? 'active' : '',
        changeMenu: !isClickDisabled ? () => changeMenu(item) : undefined,
    }))));
});
exports.MenuBar = MenuBar;
